import { render, staticRenderFns } from "./ModalMetaData.vue?vue&type=template&id=0c0fc464&scoped=true&"
import script from "./ModalMetaData.vue?vue&type=script&lang=js&"
export * from "./ModalMetaData.vue?vue&type=script&lang=js&"
import style0 from "./ModalMetaData.vue?vue&type=style&index=0&id=0c0fc464&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0fc464",
  null
  
)

export default component.exports